<template>
  <div class="app-ctrl">
    <div class="header-container mb-2">
      <b-button v-b-toggle:my-collapse
                @click="toggleMenu"
                size="sm" pill>
        <span class="when-open">{{ this.$t('Webportal.HideOptions')}}</span>
        <span class="when-closed">{{ this.$t('Webportal.ShowOptions') }}</span>
      </b-button>
    </div>

    <b-collapse id="my-collapse" v-model="collapsed">
      <b-form-checkbox-group v-model="selectedCustomColumns">
        <div class="grid-container">

          <div v-for="(group, key) in groups" :key="key" class="app-ctrl">   
            <div  v-for="(item, index) in getGroup(group)" 
                  :key="index"
                  :style="{ marginLeft: '' + getIndent(item.indent) + 'rem !important' }">

              <div  v-if="item.isHeader">
                <h6>
                  <strong>{{ item.text || '&nbsp;' }}</strong>
                </h6>
              </div>  

              <div  v-else>
                <b-form-checkbox :value="item.key" :disabled="!item.path" >
                  {{ item.text }}
                </b-form-checkbox>
              </div>  

            </div>
          </div>
        </div>
      </b-form-checkbox-group>
    </b-collapse>
  </div>
</template>

<script>
  import EventBus from "@/services/EventBus.js";
    
  export default {
    props: {
      customColumns: { type: Array, default: () => [] },
      parentTable: {type: String, required: true }
    },

    data() {
      return {
        selectedCustomColumns: [],
        collapsed: true
      }
    },

    computed: {
      groups() {
        return [...new Set(this.customColumns.map(x => x.group))];
      }
    },

    mounted() {
      EventBus.$on("grid-selected-custom-columns-initialize", this.initializeSelectedCustomColumns);
    },

    beforeDestroy() {
      EventBus.$off("grid-selected-custom-columns-initialize", this.initializeSelectedCustomColumns);
    },

    watch: {
      selectedCustomColumns: {
        handler(newVal, oldVal) {
          EventBus.$emit("grid-selected-custom-columns-changed", this.selectedCustomColumns);
        }
      }
    },

    methods: {
      getGroup(name) {
        return [...this.customColumns.filter(x => x.group == name)];
      },

      initializeSelectedCustomColumns(event) {
        this.collapsed = event.collapsed;
        this.selectedCustomColumns = event.items;
      },

      getIndent(value) {
        return value * 0.5;
      },

      toggleMenu() {
        this.collapsed = !this.collapsed;
        this.$store.commit(`${this.parentTable}MenuCollapsed`, this.collapsed);
      }
    }
  }
</script>


<style lang="scss" scoped>

  .grid-container {
    display: grid;
    grid-template-columns: auto auto auto auto auto auto;
    gap: 0.25rem;
    font-size: 15px;
    letter-spacing: -0.025em;
  }
  
  .header-container {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 0.25rem;
  }

  h6 {
    margin-bottom: 0rem;
    margin-top: 0.5rem;
  }

  .collapsed > .when-open,
  .not-collapsed > .when-closed {
    display: none;
  }
</style>